import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "16px !important",
    padding: "16px !important",
    maxWidth: "480px !important",
    width: "100% !important",
  },
  dialogTitle: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    color: "#111111 !important",
  },
  dialogContentText: {
    fontSize: "14px !important",
    color: "#555555 !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  cancelButton: {
    textTransform: "none !important",
    color: "#666666 !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  deleteButton: {
    textTransform: "none !important",
    backgroundColor: "#d32f2f !important",
    color: "#ffffff !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    "&:hover": {
      backgroundColor: "#9a0007 !important",
    },
  },
}));

export default useStyles;
